import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { usersAPI } from "../utils/usersAPI";
import { showToast } from "../components/Toast";
import Header from "../components/Header";
import { FiUser } from "react-icons/fi";

function Profile() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) {
      setForm({
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        email: user.email || "",
        phone: user.phone || "",
      });
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user?.id) return;
    try {
      setSaving(true);
      await usersAPI.updateMe({
        first_name: form.first_name.trim() || "",
        last_name: form.last_name.trim() || "",
        phone: form.phone.trim() || "",
      });
      showToast.success("Profile updated successfully");
      await refreshUser();
    } catch (err) {
      showToast.error(err?.message || "Failed to update profile");
    } finally {
      setSaving(false);
    }
  };

  if (!user) {
    return (
      <>
        <Header title="Profile" />
        <div className="page-content">
          <div className="card">
            <p>Loading...</p>
          </div>
        </div>
      </>
    );
  }

  const roleBadgeColors = {
    CLIENT: { bg: "rgba(59,130,246,0.12)", color: "#3b82f6" },
    ANALYST: { bg: "rgba(34,197,94,0.12)", color: "#22c55e" },
    ADMIN: { bg: "rgba(249,115,22,0.12)", color: "#f97316" },
  };
  const roleStyle = roleBadgeColors[user.role] || roleBadgeColors.CLIENT;

  return (
    <>
      <Header title="Profile" />
      <div className="page-content">
        {/* Account info card */}
        <div
          className="card"
          style={{
            maxWidth: "560px",
            display: "flex",
            gap: "20px",
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: "var(--primary-blue)",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 28,
              flexShrink: 0,
            }}
          >
            <FiUser />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h2 style={{ margin: 0, fontSize: 18 }}>
              {user.first_name} {user.last_name}
            </h2>
            <p style={{ margin: "4px 0 0", color: "var(--text-grey)", fontSize: 14 }}>
              {user.email}
            </p>
            <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
              <span
                style={{
                  padding: "3px 10px",
                  borderRadius: 12,
                  fontSize: 12,
                  fontWeight: 600,
                  background: roleStyle.bg,
                  color: roleStyle.color,
                }}
              >
                {user.role}
              </span>
              {user.date_joined && (
                <span style={{ fontSize: 12, color: "var(--text-grey)" }}>
                  Joined {new Date(user.date_joined).toLocaleDateString()}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Editable form */}
        <div className="card" style={{ maxWidth: "560px" }}>
          <h2 className="card-title">Edit Profile</h2>
          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              marginTop: "20px",
            }}
          >
            <div className="form-group">
              <label>First name</label>
              <input
                type="text"
                value={form.first_name}
                onChange={(e) =>
                  setForm((f) => ({ ...f, first_name: e.target.value }))
                }
                placeholder="First name"
              />
            </div>
            <div className="form-group">
              <label>Last name</label>
              <input
                type="text"
                value={form.last_name}
                onChange={(e) =>
                  setForm((f) => ({ ...f, last_name: e.target.value }))
                }
                placeholder="Last name"
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={form.email}
                disabled
                style={{
                  background: "var(--bg-grey)",
                  cursor: "not-allowed",
                  color: "var(--text-grey)",
                }}
              />
              <small style={{ color: "var(--text-grey)", fontSize: "12px" }}>
                Email cannot be changed. Contact an admin if needed.
              </small>
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input
                type="text"
                value={form.phone}
                onChange={(e) =>
                  setForm((f) => ({ ...f, phone: e.target.value }))
                }
                placeholder="+250 xxx xxx xxx"
              />
            </div>
            <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={saving}
              >
                {saving ? "Saving..." : "Save changes"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Profile;
